import React from 'react';
import './LegalPage.css';

function TermsOfUse() {
  return (
    <main className="legal-page">
      <header className="legal-header">
        <a className="legal-brand" href="/">Growth <span>Sparrow</span></a>
        <a className="legal-back" href="/">Back to website</a>
      </header>

      <article className="legal-content">
        <span className="legal-eyebrow">Growth Sparrow · Legal</span>
        <h1>Terms of Use</h1>
        <p className="legal-intro">
          These Terms explain the rules that apply when you access or use the
          Growth Sparrow website and request information about our services.
        </p>
        <p className="legal-updated">Last updated: 24 June 2025</p>

        <div className="legal-card">
          <section>
            <h2>1. Acceptance of these Terms</h2>
            <p>
              By accessing or using this website, you agree to be bound by these
              Terms of Use and our Privacy Policy. If you do not agree, please do
              not use the website.
            </p>
            <p>
              If you use the website on behalf of a business or organisation, you
              confirm that you are authorised to accept these Terms on its behalf.
            </p>
          </section>

          <section>
            <h2>2. About Growth Sparrow</h2>
            <p>
              Growth Sparrow provides information about custom appointment
              booking systems, booking workflows, software services, and related
              business solutions. Website content is provided for general
              information and does not create a client, employment, partnership,
              or agency relationship.
            </p>
          </section>

          <section>
            <h2>3. Booking requests</h2>
            <p>
              You may submit a booking request through the website by providing
              accurate contact details and selecting an available service, date,
              and time. A request is not a confirmed appointment until Growth
              Sparrow confirms it directly.
            </p>
            <ul>
              <li>Submit information that is accurate and current.</li>
              <li>Do not submit requests for another person without permission.</li>
              <li>Notify us promptly if your details or availability change.</li>
              <li>Do not use the booking flow to send spam, unlawful content, or malicious code.</li>
            </ul>
            <p>
              We may decline, cancel, or reschedule a request where availability,
              accuracy, security, or operational circumstances require it.
            </p>
          </section>

          <section>
            <h2>4. Acceptable use</h2>
            <p>
              You agree not to misuse the website or attempt to interfere with
              its operation. This includes attempting unauthorised access,
              probing or bypassing security controls, scraping content at scale,
              introducing malware, impersonating another person, or using the
              website for unlawful or fraudulent purposes.
            </p>
          </section>

          <section>
            <h2>5. Intellectual property</h2>
            <p>
              Unless otherwise stated, the Growth Sparrow name, logo, website
              design, text, graphics, software, and other content are owned by or
              licensed to Growth Sparrow and are protected by applicable
              intellectual property laws.
            </p>
            <p>
              You may view and use the website for personal or internal business
              purposes. You may not copy, modify, distribute, publish, sell,
              reverse engineer, or create derivative works from website content
              without prior written permission.
            </p>
          </section>

          <section>
            <h2>6. Third-party services and links</h2>
            <p>
              The website may contain links to third-party websites or services.
              These are provided for convenience, and Growth Sparrow does not
              control or endorse their content, security, availability, or
              privacy practices. Your use of third-party services is governed by
              their own terms and policies.
            </p>
          </section>

          <section>
            <h2>7. Disclaimers</h2>
            <p>
              The website and its content are provided on an “as available” and
              “as is” basis. We do not guarantee that the website will always be
              uninterrupted, error-free, secure, or free of harmful components.
            </p>
            <p>
              Information on the website is not legal, financial, medical, or
              professional advice. You should obtain advice from an appropriately
              qualified professional before making decisions based on the
              information provided.
            </p>
          </section>

          <section>
            <h2>8. Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, Growth Sparrow and its
              personnel will not be liable for indirect, incidental, special,
              consequential, exemplary, or punitive losses, or for loss of data,
              revenue, profits, business, goodwill, or opportunities arising from
              or related to your use of the website.
            </p>
            <p>
              Nothing in these Terms excludes or limits liability that cannot
              legally be excluded or limited.
            </p>
          </section>

          <section>
            <h2>9. Indemnity</h2>
            <p>
              To the extent permitted by law, you agree to defend, indemnify, and
              hold harmless Growth Sparrow from claims, losses, liabilities,
              damages, costs, and expenses arising from your breach of these Terms,
              misuse of the website, or violation of another person’s rights.
            </p>
          </section>

          <section>
            <h2>10. Changes and termination</h2>
            <p>
              We may modify these Terms or discontinue, suspend, or restrict any
              part of the website at any time. Updated Terms become effective
              when posted. We may also restrict access where we reasonably believe
              a user has violated these Terms or created a security or legal risk.
            </p>
          </section>

          <section>
            <h2>11. Governing law</h2>
            <p>
              These Terms are governed by the laws applicable to Growth Sparrow’s
              operating jurisdiction, without regard to conflict-of-law rules.
              Any dispute should first be raised with us in good faith so the
              parties can try to resolve it informally.
            </p>
          </section>

          <section>
            <h2>12. Contact</h2>
            <p>
              Questions about these Terms can be sent to:
            </p>
            <div className="legal-contact">
              <strong>Growth Sparrow</strong>
              <a href="mailto:office@growthsparrow.com">office@growthsparrow.com</a>
            </div>
          </section>
        </div>
      </article>

      <p className="legal-footer">© 2025 Growth Sparrow. All rights reserved.</p>
    </main>
  );
}

export default TermsOfUse;